import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import invariant from "tiny-invariant";
import {
  Button,
  FormControl,
  Box,
  Modal,
  Paper,
  useTheme,
  Typography,
  TextField,
} from "@mui/material";
import { TreeContext } from "../tree-context";
import useStyles from "./styles";
import api from "../../../../../services/api";
import { useNotification } from "../../../../notificationProvider";
import { TreeItem } from "../../data/tree";

export function DuplicateItemModal({
  onClose,
  itemId,
  item,
  open,
  status = 2,
}: {
  onClose: () => void;
  open: boolean;
  itemId: string;
  item: TreeItem;
  status?: number;
}) {
  const { dispatch } = useContext(TreeContext);
  const [title, setTitle] = useState(item.title || "");
  const [path, setPath] = useState(item.path || "");
  const [loading, setLoading] = useState(false);
  const [errorForm, setErrorForm] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const notify = useNotification();
  useEffect(() => {
    setTitle(item.title || "");
    setPath(item.path || "");
  }, [item]);
  useEffect(() => {
    setErrorForm(false);
  }, [open]);
  async function handleDuplicatePageApi(
    id: string,
    path: string,
    title: string
  ): Promise<any | null | undefined> {
    try {
      setLoading(true);
      const response = await api.post(
        "/pages/duplicate",
        {
          id,
          status: 2,
          title,
          path,
        }
        // { signal }
      );
      if (response.status === 200) {
        notify(response.status, "Página duplicada com sucesso", "success");
        // console.log("Duplicate page data:", response.data);
        return response.data;
      }
    } catch (error: any) {
      if (error.code && !error.response) {
        notify(error.code, error.message, "error");
      } else {
        notify(error.status, error?.response?.data.message, "error");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
    return null;
  }
  async function handleButtonSubmitDuplicate() {
    if (item.title === title && item.path === path) {
      setErrorForm(true);
      return;
    }
    setErrorForm(false);
    const data = await handleDuplicatePageApi(itemId, path, title);
    if (!data || !data.newPage) {
      return;
    }
    const newItem = data?.newPage;
    const parentId = data?.parent?.id || null;
    if (data.parent)
      dispatch({
        type: "create-child",
        itemId: newItem.id,
        parentId,
        newItem: {
          id: newItem.id,
          title: newItem.title,
          path: newItem.path,
          type: newItem.type,
          status: newItem.status,
          position: newItem.position,
          children: [],
        },
      });
    else
      dispatch({
        type: "create",
        itemId: newItem.id,
        newItem: {
          id: newItem.id,
          title: newItem.title,
          path: newItem.path,
          type: newItem.type,
          status: newItem.status,
          position: newItem.position,
          children: [],
        },
      });
    onClose();
  }

  function slugify(text: string): string {
    return (
      "/" +
      text
        .trim() // Remove espaços do início e do fim
        .toLowerCase() // Transforma tudo em minúsculas
        .replace(/ç/g, "c") // substitui cedilha manualmente
        .normalize("NFD") // Remove acentos
        .replace(/[\u0300-\u036f]/g, "") // Remove diacríticos (acentos etc.)
        .replace(/[^a-z0-9]+/g, "-") // Substitui qualquer caractere não alfanumérico por "-"
    );
  }
  useEffect(() => {
    setPath(slugify(title));
  }, [title]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      // Simula o clique no botão ao pressionar Enter
      buttonRef.current?.click();
    }
  };
  return (
    <Modal open={open} closeAfterTransition onClose={onClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        {/* <form onSubmit={onSubmit}> */}
        <Box sx={styles.boxHeader}>
          <Typography variant="h6">
            {"Digite um novo nome pra página duplicada"}
          </Typography>
        </Box>
        <Box sx={styles.boxContent}>
          {/* <Box display="flex" flexDirection="column" gap={2} mt={1}> */}
          {/* <FormControl fullWidth required> */}
          <TextField
            label="Título"
            variant="filled"
            name="title"
            required
            autoFocus
            onKeyDown={handleKeyDown}
            value={title}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setTitle(e.target.value)
            }
            error={errorForm}
            helperText={errorForm && "Não pode ser igual ao original"}
            // sx={styles.textField}
          />
          <TextField
            label="Path"
            variant="filled"
            name="path"
            disabled={true}
            // required
            autoFocus
            value={path}
            error={errorForm}
            helperText={errorForm && "Não pode ser igual ao original"}
            // onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            //   setPath(slugify(e.target.value))
            // }
            // sx={styles.textField}
          />
          {/* </FormControl> */}
          {/* </Box> */}
        </Box>
        <Box sx={styles.boxActions}>
          <Button onClick={onClose} variant="outlined" disabled={loading}>
            Cancelar
          </Button>
          <Button
            ref={buttonRef}
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={handleButtonSubmitDuplicate}
          >
            Adicionar
          </Button>
        </Box>
        {/* </form> */}
      </Paper>
    </Modal>
  );
}
